<tile
  (onClick)="onClick.emit()"
  [active]="active"
  [title]="data?.title"
  [media]="data?.media"
  tileType="wide-image-tile"
  [hoverActive]="hoverActive"
>
  <ng-content></ng-content>
</tile>
